import { render, staticRenderFns } from "./BaseNavbar.vue?vue&type=template&id=db91fa30&scoped=true"
import script from "./BaseNavbar.vue?vue&type=script&lang=js"
export * from "./BaseNavbar.vue?vue&type=script&lang=js"
import style0 from "./BaseNavbar.vue?vue&type=style&index=0&id=db91fa30&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db91fa30",
  null
  
)

export default component.exports